// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 117) return "css/core.117.7596da375dfd30c9e3e5.main.css";
	if (chunkId === 179) return "css/core.main.c9a0ca0ea1e6cb89755e.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"172":"bot","405":"cfd","897":"id-json"}[chunkId] + "." + {"172":"402edf283f3cb6f1753c","405":"fc559ec00b7435aaa806","897":"0ddf76b2271c2c6540a1"}[chunkId] + ".css";
};